import React, { useEffect, useState } from 'react';
import ConversationModal from './ConversationModal';
import InviteParticipantsModal from '../InviteParticipantsModal';
import { useDispatch, useSelector } from 'react-redux';
import {
  conversations as conversationsSelector,
  currentConversationId,
} from '@core/conversations/selectorsResponsive';
import fetchConversation from '@core/conversations/operations/fetchConversation.action';

interface ConversationModalWithInviteProps {
  [key: string]: any;
}

const ConversationModalWithInvite: React.FC<
  ConversationModalWithInviteProps
> = (props) => {
  const [inviteModalOpen, setInviteModalOpen] = useState(false);

  const handleOpenAddParticipant = () => {
    setInviteModalOpen(true);
  };

  const handleCloseInviteModal = () => {
    setInviteModalOpen(false);
  };

  // Override the openAddParticipant prop to use our new modal
  const modifiedProps = {
    ...props,
    openAddParticipant: handleOpenAddParticipant,
  };

  const conversations = useSelector(conversationsSelector);
  const currentConvId = useSelector(currentConversationId);
  const dispatch = useDispatch();
  const { conversation } = props;
  useEffect(() => {
    if (Object.keys(conversations).length && !conversation) {
      dispatch(fetchConversation(currentConvId));
    }
  }, [conversations, conversation]);

  return (
    <>
      <ConversationModal {...modifiedProps} />
      <InviteParticipantsModal
        open={inviteModalOpen}
        onClose={handleCloseInviteModal}
        conversationId={props.groupId}
      />
    </>
  );
};

export default ConversationModalWithInvite;
